import React from 'react';
import { Icon } from '@chakra-ui/icons';

export const ActionBackIcon = ({ color = 'white', ...props }: { color?: string } | any) => {
	return (
		<Icon
			width="auto"
			height="32px"
			viewBox="0 0 31 31"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M18.0833 9.0415L11.625 15.4998L18.0833 21.9582"
				stroke={color}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Icon>
	);
};
